export default __webpack_public_path__ + "static/media/acha_prof.3a882d1e.png";